/* eslint-disable no-unused-vars */

var subDomain = "api";
if (window.location.host != "www.myptmyra.com" && window.location.host != "myptmyra.com" && window.location.host !== "www.startfreept.com" && window.location.host !== "startfreept.com" && window.location.host !== "virdiohealth.com" && window.location.host !== "www.virdiohealth.com") {
  subDomain = "uatapi";
}

// ANALYTICS: Define the base URL for the new analytics API endpoint.
const ANALYTICS_API_URL = "https://" + subDomain + ".virdiohealth.com/api/v1/assessment";

let chatLogQueue = Promise.resolve();

window.trSessionId = localStorage.getItem("trSessionId") || "";

function getUrlTrackingFields() {
  const params = new URLSearchParams(window.location.search);

  const variant = params.get("variant") || localStorage.getItem("variant") || null;
  const gclid = params.get("gclid");
  const gbraid = params.get("gbraid");
  const wbraid = params.get("wbraid");

  const hasGoogleClickId = Boolean(gclid || gbraid || wbraid || variant);

  const fields = {};

  if (variant) {
	  localStorage.setItem("variant", variant);
	  fields.variant = variant;
  }
  if (gclid) fields.gclid = gclid;
  if (gbraid) fields.gbraid = gbraid;
  if (wbraid) fields.wbraid = wbraid;

  if (hasGoogleClickId) {
    fields.isComeFromGoogle = true;
  }

  return fields;
}
// Race-condition guard: holds the in-flight startSession promise so
// concurrent callers wait for the first call instead of creating duplicates.
let _pendingSessionPromise = null;

let _pendingIpPromise = null;
let _pendingFrontIpSessionUpdatePromise = null;

function wait(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

function ensureFrontIp(timeoutMs) {
  if (window.backupIP) {
    return Promise.resolve(window.backupIP);
  }

  if (!_pendingIpPromise) {
    _pendingIpPromise = fetch("https://virdio.weborik.com/init.php")
      .then((res) => {
        if (!res.ok) {
          throw new Error("Failed to fetch front IP");
        }

        return res.json();
      })
      .then((data) => {
        window.backupIP = data?.session || "";
        return window.backupIP;
      })
      .catch((error) => {
        console.warn("ensureFrontIp Error:", error);
        return "";
      })
      .finally(() => {
        _pendingIpPromise = null;
      });
  }

  // If timeoutMs is provided, allow callers to use the old timeout behavior.
  // If not provided, wait until the IP request truly finishes.
  if (typeof timeoutMs === "number") {
    return Promise.race([
      _pendingIpPromise,
      wait(timeoutMs).then(() => window.backupIP || ""),
    ]);
  }

  return _pendingIpPromise;
}

function startFrontIpUpdateAfterSession(sessionId) {
  if (!sessionId) return;

  // Avoid duplicate background IP updates.
  if (_pendingFrontIpSessionUpdatePromise) return;

  // If IP is already known, no need to refetch.
  // The session_start payload already includes cached window.backupIP if available.
  if (window.backupIP) return AnalyticsService.trackStep({}, null, { frontIpOnly: true });

  _pendingFrontIpSessionUpdatePromise = ensureFrontIp()
    .then((frontIp) => {
      if (!frontIp) return;

      window.trSessionId = window.trSessionId || sessionId;

      // IP-only update. Does not resend/overwrite assessment data.
      return AnalyticsService.trackStep({}, null, { frontIpOnly: true });
    })
    .catch((error) => {
      console.warn("Background front IP update failed:", error);
    })
    .finally(() => {
      _pendingFrontIpSessionUpdatePromise = null;
    });
}

// ANALYTICS: Create a helper service to manage all analytics API calls.
export const AnalyticsService = {
  /**
   * Starts a new analytics session when the user first lands on the page.
   * Uses a pending-promise guard to prevent duplicate session creation
   * when multiple components call startSession() simultaneously.
   * @returns {Promise<string|null>} The unique session ID from the backend, or null on failure.
   */
  startSession: (trackingFields = {}) => {
	  const existingSessionId = window.trSessionId || localStorage.getItem("trSessionId");

	  if (existingSessionId) {
		window.trSessionId = existingSessionId;

		// Best-effort background IP update if needed.
		startFrontIpUpdateAfterSession(existingSessionId);

		return Promise.resolve(existingSessionId);
	  }

	  if (_pendingSessionPromise) {
		return _pendingSessionPromise;
	  }

	  _pendingSessionPromise = (async () => {
		try {
		  function getDeviceType() {
			const ua = navigator.userAgent;

			if (/iPad|Tablet|Nexus 7|Nexus 10|SM-T|Tab/i.test(ua)) {
			  return "tablet";
			}

			if (/Mobi|Android|iPhone|iPod|Phone/i.test(ua)) {
			  return "mobile";
			}

			return "desktop";
		  }

		  const urlTrackingFields = getUrlTrackingFields();
		  
		  if ( window.backupIP ) {
			localStorage.setItem("bckip", window.backupIP);
		  }

		  const payload = {
			event: "session_start",
			device_info: navigator.userAgent,
			session_start_time: new Date().toISOString(),

			// Do not wait for IP here.
			// If already known, send it. Otherwise send empty and update later.
			front_ip: window.backupIP || localStorage.getItem("bckip") || "",
			
			variant_save: localStorage.getItem("variant") || "",

			device_type: getDeviceType() + " | " + window.location.host.replace("www.", ""),

			// Caller can still add non-URL fields or override deliberately.
			...trackingFields,

			// URL-derived attribution should always be present when available.
			...urlTrackingFields,
		  };

		  const response = await fetch(`${ANALYTICS_API_URL}/init`, {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(payload),
		  });

		  if (!response.ok) throw new Error("Failed to start session");

		  const data = await response.json();

		  localStorage.setItem("trSessionId", data.session_id);
		  window.trSessionId = data.session_id;

		  // Start IP fetch/update only after session exists.
		  // Do not await this.
		  startFrontIpUpdateAfterSession(data.session_id);
		  setTimeout(() => { startFrontIpUpdateAfterSession(data.session_id); }, 2000);
		  setTimeout(() => { startFrontIpUpdateAfterSession(data.session_id); }, 10000);

		  return data.session_id;
		} catch (error) {
		  console.error("AnalyticsService.startSession Error:", error);
		  return null;
		} finally {
		  _pendingSessionPromise = null;
		}
	  })();

	  return _pendingSessionPromise;
	},

  /**
   * Tracks a specific step in the user's journey.
   * @param {object} assessmentData - The complete, current state of the user's assessment answers.
   */
  trackStep: async (assessmentData = {}, callback, options = {}) => {
	  window.trSessionId = window.trSessionId || localStorage.getItem("trSessionId") || "";

	  if (!window.trSessionId && !options.frontIpOnly) {
		await AnalyticsService.startSession();
		window.trSessionId = window.trSessionId || localStorage.getItem("trSessionId") || "";
	  }

	  if (!window.trSessionId) {
		console.warn("AnalyticsService.trackStep: No session ID provided.");
		return;
	  }
	  
	  if ( window.backupIP ) { localStorage.setItem("bckip", window.backupIP); }

	  try {
		const payload = {
		  session_id: window.trSessionId,
		  session_last_update: new Date().toISOString(),
		  front_ip: window.backupIP || localStorage.getItem("bckip") || "",
		  variant_save: localStorage.getItem("variant") || "",
		};

		if (!options.frontIpOnly) {
		  let enhancedData = {
			...assessmentData,
			analyticsId: window.trSessionId,
		  };

		  if (window.timeTracker) {
			const currentGSADuration = window.timeTracker.getGSADuration();

			if (currentGSADuration !== null) {
			  enhancedData.gsaDurationSec = currentGSADuration;
			  console.log(`Current GSA duration: ${currentGSADuration} seconds`);
			}
		  }

		  payload.assessment_data = enhancedData;
		}
		
		if ( options.frontIpOnly && !payload.front_ip ) {
			console.warn("AnalyticsService.trackStep: Not found.");
			return;
		}

		fetch(`${ANALYTICS_API_URL}/data`, {
		  method: "POST",
		  headers: { "Content-Type": "application/json" },
		  body: JSON.stringify(payload),
		})
		  .then((resp) => {
			if (!resp.ok) {
			  throw new Error("Failed to track analytics event");
			}

			if (options.frontIpOnly) {
			  console.log(`Front IP updated for session ${window.trSessionId}:`, window.backupIP);
			} else {
			  console.log(`Analytics event tracked for session ${window.trSessionId}:`, assessmentData);
			}

			if (callback) {
			  callback();
			}
		  })
		  .catch((error) => {
			console.error("AnalyticsService.trackStep fetch Error:", error);
		  });
	  } catch (error) {
		console.error("AnalyticsService.trackStep Error:", error);
	  }
	},
  logChatTurn: async ({ role = "assistant", content = "", turnNumber = 0, touchpoint = "gsa_mid_journey", flow = "flow_gsa", intent = null, source = "frontend_injected", inputMethod = "frontend" } = {}) => {
    const task = async () => {
      window.trSessionId = window.trSessionId || localStorage.getItem("trSessionId") || "";

      if (!window.trSessionId) {
        await AnalyticsService.startSession();
        window.trSessionId = window.trSessionId || localStorage.getItem("trSessionId") || "";
      }

      const text = String(content || "").trim();
      if (!window.trSessionId || !text) return;

      const response = await fetch(`${ANALYTICS_API_URL}/chat/log-turn`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          session_id: window.trSessionId,
          role,
          content: text,
          turnNumber,
          touchpoint,
          flow,
          intent,
          source,
          inputMethod,
        }),
      });

      if (!response.ok) {
        throw new Error("Failed to log chat turn");
      }

      return await response.json();
    };

    chatLogQueue = chatLogQueue.then(task, task).catch((error) => {
      console.error("AnalyticsService.logChatTurn Error:", error);
    });

    return chatLogQueue;
  },
  saveFullData: async (fullData) => {
    window.trSessionId = window.trSessionId || localStorage.getItem("trSessionId") || "";

    if (!window.trSessionId) {
      console.warn("AnalyticsService.saveFullData: No session ID found.");
      return;
    }

    try {
      const payload = {
        session_id: window.trSessionId,
        fullData,
      };

      const response = await fetch(`${ANALYTICS_API_URL}/fulldata`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await response.json();
      console.log("Full data saved:", data);
      return data;
    } catch (error) {
      console.error("AnalyticsService.saveFullData Error:", error);
    }
  },
};

// Add this utility at the top of your homescreen.jsx or create a separate file
class TimeTracker {
  constructor() {
    this.landingStartTime = null;
    this.gsaStartTime = null;
  }

  // Call this when landing page loads
  startLandingTimer() {
    this.landingStartTime = Date.now();
    console.log("Landing timer started");
  }

  // Call this when user clicks "Start GSA"
  startGSATimer() {
    this.gsaStartTime = Date.now();
    console.log("GSA timer started");

    // Also calculate time spent on landing
    if (this.landingStartTime) {
      const landingDurationSec = Math.round((this.gsaStartTime - this.landingStartTime) / 1000);
      return {
        gsaStartedAt: new Date().toISOString(),
        timeOnLandingSec: landingDurationSec,
      };
    }

    return {
      gsaStartedAt: new Date().toISOString(),
      timeOnLandingSec: null,
    };
  }

  // Call this on each screen to get updated GSA duration
  getGSADuration() {
    if (!this.gsaStartTime) return null;
    return Math.round((Date.now() - this.gsaStartTime) / 1000);
  }

  // Reset all timers (when user restarts)
  reset() {
    this.landingStartTime = null;
    this.gsaStartTime = null;
  }
}

// Create global instance
window.timeTracker = new TimeTracker();

// Add this to your homescreen.jsx or utilities
class ScreenFlowTracker {
  constructor() {
    this.screenFlow = [];
  }

  // Call when entering a screen
  enterScreen(screenName) {
    const entry = {
      screen: screenName,
      enteredAt: new Date().toISOString(),
      completed: false,
    };
    this.screenFlow.push(entry);
    console.log(`Entered screen: ${screenName}`);
    return entry;
  }

  // Call when completing/exiting a screen
  exitScreen(screenName, options = {}) {
    const screen = [...this.screenFlow].reverse().find((s) => s.screen === screenName && !s.completed);
    if (screen) {
      screen.completed = options.completed !== undefined ? options.completed : true;
      screen.exitedAt = new Date().toISOString();
      screen.duration = Math.max(0, new Date(screen.exitedAt).getTime() - new Date(screen.enteredAt).getTime());

      // Add optional exit reason
      if (options.exitReason) {
        screen.exitReason = options.exitReason;
      }

      console.log(`Exited screen: ${screenName}`, options);
    }
    return screen;
  }

  recordEvent(screenName, event, value = null) {
    const screen = [...this.screenFlow].reverse().find((s) => s.screen === screenName && !s.completed);
    if (!screen || !event) return null;
    if (!Array.isArray(screen.events)) screen.events = [];
    const entry = {
      event,
      timestamp: new Date().toISOString(),
    };
    if (value !== undefined && value !== null) entry.value = value;
    screen.events.push(entry);
    return entry;
  }

  // Get current screen flow data
  getScreenFlow() {
    return [...this.screenFlow];
  }

  // Reset for new session
  reset() {
    this.screenFlow = [];
  }
}

// Create global instance
window.screenTracker = new ScreenFlowTracker();

// custom hook which will scroll to top when component mounts
const useScrollToTop = () => {
  // useEffect(() => {
  //   window.scrollTo({ top: 0, behavior: "smooth" });
  // }, []);
  /*useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);*/
};

